import Reveal from '../Components/Reveal';
import '../styles/Solutions.css';
import serviceImg from '../Assets/pinwheel.jpg';
import biDashboardImg from '../Assets/BI Dashboard1.jpg';
import aiAgentImg from '../Assets/AI Agent1.png';
import vrFusionImg from '../Assets/Exploring urban designs with VR technology.png';

const Solutions = () => (
  <>
    {/* ── Section 1: Hero ──────────────────────────────────── */}
    <section className="ew-sol-hero">
      <div className="ew-sol-hero__inner">
        <div className="ew-sol-hero__card">
          <img
            className="ew-sol-hero__img"
            src={serviceImg}
            alt="Industrial intelligence hero"
          />
          <div className="ew-sol-hero__overlay">
            <Reveal>
              <p className="ew-sol-hero__eyebrow">Industrial Intelligence</p>
              <h1 className="ew-sol-hero__heading">
                Autonomous<br />
                <span className="ew-sol-hero__heading-muted">Intelligence &amp;</span><br />
                Digital Twins
              </h1>
              <p className="ew-sol-hero__sub">
                From AI-driven agentic workflows to immersive industrial digital twins,
                our solutions are purpose-engineered for the energy sector — delivering
                operational visibility, automation, and intelligence at every layer of
                your asset lifecycle.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>

    {/* ── Section 2: Agents & BI ───────────────────────────── */}
    <section className="ew-sol-agents">
      <div className="ew-sol-agents__inner">

        {/* 2a — Section header */}
        <Reveal>
          <div className="ew-sol-agents__header">
            {/* Left */}
            <div>
              <p className="ew-sol-agents__eyebrow">The New Standard</p>
              <h2 className="ew-sol-agents__heading">Agents &amp; BI Dashboard</h2>
              <p className="ew-sol-agents__body">
                We develop AI agents that can define, execute, and optimize complex
                technical workflows, turning your operational chaos into meaningful
                strategic insights.
              </p>
            </div>
            {/* Right — stacked image pair */}
            <div className="ew-sol-agents__imgs">
              <img
                className="ew-sol-agents__img ew-sol-agents__img--offset"
                src={biDashboardImg}
                alt="BI dashboard analytics"
              />
              <img
                className="ew-sol-agents__img"
                src={aiAgentImg}
                alt="AI agent workflow"
              />
            </div>
          </div>
        </Reveal>

        {/* 2b — Feature Card: AI Agents (text left, image right) */}
        <Reveal>
          <div className="ew-sol-feature">
            <div className="ew-sol-feature__content">
              <h4 className="ew-sol-feature__title">AI Agents &amp; Agentic Workflow</h4>
              <p className="ew-sol-feature__body">
                Developing self-correcting AI systems that manage complex multi-step
                technical tasks without constant manual oversight.
              </p>
              <ul className="ew-sol-feature__list">
                <li className="ew-sol-feature__item">
                  <span className="ew-sol-feature__icon">&#8594;</span>
                  <span className="ew-sol-feature__label">Task Definition &amp; Planning</span>
                </li>
                <li className="ew-sol-feature__item">
                  <span className="ew-sol-feature__icon">&#8594;</span>
                  <span className="ew-sol-feature__label">Autonomous Execution</span>
                </li>
                <li className="ew-sol-feature__item">
                  <span className="ew-sol-feature__icon">&#8594;</span>
                  <span className="ew-sol-feature__label">Self-Reflection &amp; Optimization</span>
                </li>
              </ul>
            </div>
            <img
              className="ew-sol-feature__img"
              src={aiAgentImg}
              alt="AI agents workflow visualization"
            />
          </div>
        </Reveal>

        {/* 2c — Feature Card: Enterprise BI (image left, text right) */}
        <Reveal>
          <div className="ew-sol-feature" style={{ marginBottom: '6rem' }}>
            <img
              className="ew-sol-feature__img"
              src={biDashboardImg}
              alt="Enterprise BI dashboard"
            />
            <div className="ew-sol-feature__content">
              <h4 className="ew-sol-feature__title">Enterprise BI</h4>
              <p className="ew-sol-feature__body">
                Interactive dashboards that breathe life into raw datasets, providing
                decision-makers with the clarity needed for agile operations.
              </p>
              <ul className="ew-sol-feature__list">
                <li className="ew-sol-feature__item">
                  <span className="ew-sol-feature__icon">&#10003;</span>
                  <span className="ew-sol-feature__label">Real-Time Operational Visibility</span>
                </li>
                <li className="ew-sol-feature__item">
                  <span className="ew-sol-feature__icon">&#10003;</span>
                  <span className="ew-sol-feature__label">SLA &amp; Data Growth Tracking</span>
                </li>
              </ul>
            </div>
          </div>
        </Reveal>

        {/* 2d — Case Studies */}
        <div className="ew-sol-cases">
          <Reveal>
            <div className="ew-sol-cases__header">
              <p className="ew-sol-cases__eyebrow">Proven Performance</p>
              <h3 className="ew-sol-cases__heading">Selected Case Studies</h3>
              <p className="ew-sol-cases__sub">
                Discover how we've delivered measurable ROI for major energy players by
                bridging the gap between raw technical data and operational clarity.
              </p>
            </div>
          </Reveal>
          <div className="ew-sol-cases__grid">
            {/* Card 1 — Subsurface */}
            <Reveal>
              <div className="ew-sol-case-card">
                <div className="ew-sol-case-card__glow ew-sol-case-card__glow--orange" />
                <div className="ew-sol-case-card__top">
                  <span className="ew-sol-case-card__tag">Unified Intelligent Environment</span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7"/>
                    <path d="M3 11h18"/><path d="M15 19l2 2 4-4"/>
                  </svg>
                </div>
                <h4 className="ew-sol-case-card__title">Subsurface Data Operation Monitoring &amp; Insights</h4>
                <p className="ew-sol-case-card__body">
                  We established an intelligent digital ecosystem to centralize all subsurface
                  data activities. By linking fragmented datasets into a single source of truth,
                  we empowered leadership with real-time visibility into operational health.
                </p>
                <div className="ew-sol-case-card__metrics">
                  <div>
                    <span className="ew-sol-case-card__metric-label">Key Outcome</span>
                    <p className="ew-sol-case-card__metric-val">Real-time SLA Tracking</p>
                  </div>
                  <div>
                    <span className="ew-sol-case-card__metric-label">Impact</span>
                    <p className="ew-sol-case-card__metric-val">Data-Driven Decisioning</p>
                  </div>
                </div>
              </div>
            </Reveal>
            {/* Card 2 — UPMI */}
            <Reveal delay={150}>
              <div className="ew-sol-case-card">
                <div className="ew-sol-case-card__glow ew-sol-case-card__glow--gray" />
                <div className="ew-sol-case-card__top">
                  <span className="ew-sol-case-card__tag">PETRONAS Global Deployment</span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2v10"/><path d="m16 8-4 4-4-4"/>
                    <path d="M12 22v-4"/><path d="m16 18-4 4-4-4"/>
                  </svg>
                </div>
                <h4 className="ew-sol-case-card__title">Upstream Model Insights (UPMI) Dashboard</h4>
                <p className="ew-sol-case-card__body">
                  Transformed fragmented model management workflows within PETRONAS into a
                  structured, centralized process. We replaced slow, manual model tracking
                  with a visualized, high-performance technical environment.
                </p>
                <div className="ew-sol-case-card__metrics">
                  <div>
                    <span className="ew-sol-case-card__metric-label">Project Scope</span>
                    <p className="ew-sol-case-card__metric-val">Enterprise-wide BI</p>
                  </div>
                  <div>
                    <span className="ew-sol-case-card__metric-label">Efficiency Gain</span>
                    <p className="ew-sol-case-card__metric-val">Centralized Traceability</p>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

      </div>
    </section>

    {/* ── Section 3: FusionSite 360XR ─────────────────────── */}
    <section className="ew-sol-fusion">
      <div className="ew-sol-fusion__card">
        <div className="ew-sol-fusion__inner">

          {/* Top 2-col grid */}
          <div className="ew-sol-fusion__top">
            {/* Left content */}
            <Reveal>
              <div>
                <p className="ew-sol-fusion__eyebrow">Industrial Metaverse</p>
                <h2 className="ew-sol-fusion__heading">FusionSite360XR</h2>
                <p className="ew-sol-fusion__body">
                  XR-enabled Industrial Digital Twin platform enabling real-time
                  monitoring and proactive management across project lifecycles.
                </p>
                <div className="ew-sol-fusion__features">
                  <div className="ew-sol-fusion__feat">
                    <div className="ew-sol-fusion__feat-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>
                    </div>
                    <span className="ew-sol-fusion__feat-label">IoT Asset Monitoring</span>
                  </div>
                  <div className="ew-sol-fusion__feat">
                    <div className="ew-sol-fusion__feat-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18"/><path d="M5 21V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14"/><path d="M9 21V11h6v10"/><path d="M7 9h.01"/><path d="M17 9h.01"/><path d="M7 13h.01"/><path d="M17 13h.01"/></svg>
                    </div>
                    <span className="ew-sol-fusion__feat-label">4D Simulation</span>
                  </div>
                  <div className="ew-sol-fusion__feat">
                    <div className="ew-sol-fusion__feat-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                    </div>
                    <span className="ew-sol-fusion__feat-label">AR Field Workflows</span>
                  </div>
                  <div className="ew-sol-fusion__feat">
                    <div className="ew-sol-fusion__feat-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                    </div>
                    <span className="ew-sol-fusion__feat-label">Remote Collaboration</span>
                  </div>
                </div>
              </div>
            </Reveal>

            {/* Right image */}
            <Reveal delay={200}>
              <div className="ew-sol-fusion__img-wrap ew-sol-fusion__floating">
                <img
                  className="ew-sol-fusion__img"
                  src={vrFusionImg}
                  alt="FusionSite360XR industrial metaverse"
                />
                <div className="ew-sol-fusion__img-glow" />
              </div>
            </Reveal>
          </div>

          {/* Case study card */}
          <Reveal>
            <div className="ew-sol-fusion__case">
              <div className="ew-sol-fusion__case-grid">
                {/* Col 1 */}
                <div className="ew-sol-fusion__case-left">
                  <p className="ew-sol-fusion__case-label">Success Story</p>
                  <h3 className="ew-sol-fusion__case-title">Terminal Modernization</h3>
                  <span className="ew-sol-fusion__case-badge">National Energy Company</span>
                  <p className="ew-sol-fusion__case-body">
                    Managed the full construction lifecycle from design through handover
                    for a critical terminal facility.
                  </p>
                </div>
                {/* Col 2 — 2×2 achievements */}
                <div className="ew-sol-fusion__case-right">
                  <div>
                    <p className="ew-sol-fusion__case-item-title">&#10003; 4D Planning</p>
                    <p className="ew-sol-fusion__case-item-body">
                      Integrated construction sequencing with real-time progress
                      tracking, reducing schedule deviations by 35%.
                    </p>
                  </div>
                  <div>
                    <p className="ew-sol-fusion__case-item-title">&#10003; IoT Integration</p>
                    <p className="ew-sol-fusion__case-item-body">
                      Connected over 2,000 field sensors to a live digital twin,
                      enabling predictive maintenance and anomaly detection.
                    </p>
                  </div>
                  <div>
                    <p className="ew-sol-fusion__case-item-title">&#10003; HSE Compliance</p>
                    <p className="ew-sol-fusion__case-item-body">
                      AR-guided safety workflows cut incident response time by 50%
                      and improved permit-to-work accuracy across all zones.
                    </p>
                  </div>
                  <div>
                    <p className="ew-sol-fusion__case-item-title">&#10003; Full Lifecycle</p>
                    <p className="ew-sol-fusion__case-item-body">
                      Persistent digital twin spans design, construction, and
                      operations — forming a single source of truth for the asset.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

        </div>
      </div>
    </section>

    {/* ── Section 4: Final CTA ─────────────────────────────── */}
    <section className="ew-sol-cta">
      <div className="ew-sol-cta__card">
        <img
          className="ew-sol-cta__img"
          src="https://images.unsplash.com/photo-1516937941344-00b4e0337589?auto=format&fit=crop&q=80&w=2000"
          alt="Precision engineering"
        />
        <div className="ew-sol-cta__overlay" />
        <Reveal>
          <div className="ew-sol-cta__inner">
            <p className="ew-sol-cta__eyebrow">Excellence in Execution</p>
            <h2 className="ew-sol-cta__heading">
              Precision Isn't Optional.<br />
              <span className="ew-sol-cta__heading-muted">Neither is Intelligence.</span>
            </h2>
            <p className="ew-sol-cta__sub">
              Whether it's subsurface data or terminal infrastructure, we ensure
              100% visibility across the asset lifecycle. Join the global leaders
              who are already leveraging Teczo to unlock actionable intelligence.
            </p>
            <div className="ew-sol-cta__btns">
              <button className="ew-sol-cta__btn">Contact Our Experts</button>
              <button className="ew-sol-cta__btn-outline">Request Solution Brief</button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Solutions;
